import React from "react"
import {
    Card, CardHeader, CardText, Paper, FontIcon,
    Table, TableHeader, TableBody, TableRow, TableHeaderColumn, TableRowColumn
} from "material-ui"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import { IPayrollExportHistoryDocument, IPayrollExportEmployeeData } from "../../models"
import moment from "moment"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import { CSVLink } from "react-csv"

interface IProps {
    historyList: IPayrollExportHistoryDocument[]
}
interface IState {
    expanded: boolean
}

export default class PayrollExportHistoryCard extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            expanded: false
        }
        autobind(this)
    }

    render() {
        if (this.props.historyList === null) return null
        return (
            <Paper
                zDepth={1}
                className="page-paper"
                style={{ marginTop: -5, marginBottom: 25, paddingTop: 0 }}>
                <Card
                    data-intercom-target="Payroll_Export_History_Card"
                    expanded={this.state.expanded}
                    onExpandChange={() => this.setState({ expanded: !this.state.expanded })}
                >
                    <CardHeader
                        showExpandableButton
                        actAsExpander
                        title={strings.Payroll_Export_History}
                        openIcon={
                            <i
                                data-intercom-target={"Payroll_Export_History_OpenIcon"}
                                className="fa fa-chevron-up itemActionButton"
                            />
                        }
                        closeIcon={
                            <i
                                data-intercom-target={"Payroll_Export_History_CloseIcon"}
                                className="fa fa-chevron-down itemActionButton"
                            />
                        }
                        iconStyle={{ fontSize: 20 }}
                        titleStyle={{ fontSize: 15, fontWeight: this.state.expanded ? "500" : "bold" }}
                    />
                    <CardText expandable>
                        {this.props.historyList.length === 0 ?
                            <div style={{ textAlign: "center" }}>{strings.No_Payroll_Export_History} </div> :
                            <Table>
                                <TableHeader
                                    displaySelectAll={false}
                                    adjustForCheckbox={false}
                                >
                                    <TableRow>
                                        <TableHeaderColumn>{strings.Date}</TableHeaderColumn>
                                        <TableHeaderColumn>{strings.Account_User}</TableHeaderColumn>
                                        <TableHeaderColumn>{strings.Payroll_Hierarchy}</TableHeaderColumn>
                                        <TableHeaderColumn>{strings.Employee_Count_Attempted}</TableHeaderColumn>
                                        <TableHeaderColumn>{strings.Successful_Exports}</TableHeaderColumn>
                                        <TableHeaderColumn>{strings.Failed_Exports}</TableHeaderColumn>
                                        <TableHeaderColumn style={{ width: 100, textAlign: "center" }}>{strings.Export_Report}</TableHeaderColumn>
                                    </TableRow>
                                </TableHeader>
                                <TableBody displayRowCheckbox={false}>
                                    {this.props.historyList.map((row, index) => {
                                        const payrollHierarchyNames = row.PayrollHierarchyIds.map(i => hierarchyHelper.getHierarchyItemNameByHierarchyId(i)).join(", ")
                                        const downloadData = [
                                            [strings.Payroll_Hierarchy, strings.Name, strings.Exported, strings.Exported_Date, strings.Exported_By, strings.Export_Note, strings.Audit]
                                        ]
                                        const groupedExportData = row.ExportedData.reduce((groups, item) => {
                                            const category = item.PayrollHierarchyId
                                            if (!groups[category]) {
                                                groups[category] = []
                                            }
                                            groups[category].push(item)
                                            return groups
                                        }, {})
                                        const payrollHierarchyIds = Object.keys(groupedExportData)
                                        payrollHierarchyIds.forEach((hierarchyId, index) => {
                                            index > 0 &&
                                                downloadData.push([])
                                            downloadData.push([`${hierarchyHelper.getHierarchyItemNameByHierarchyId(hierarchyId)}`])
                                            groupedExportData[hierarchyId].forEach((exportedData: IPayrollExportEmployeeData) => {
                                                const employeeName = exportedData.Name
                                                const exported = exportedData.Exported ? strings.Exported : strings.Failed
                                                const exportedDate = moment(row.ExportedDateTime).format("MM-DD-YYYY")
                                                const exportedBy = row.ExportedUserName
                                                let exportNote = exportedData.ExportNote
                                                let audit = exportedData.AuditLog
                                                downloadData.push(["", employeeName, exported, exportedDate, exportedBy, exportNote, audit])
                                            })
                                        })
                                        return (
                                            <TableRow key={index}>
                                                <TableRowColumn>{moment(row.ExportedDateTime).format("YYYY-MM-DD hh:mma")}</TableRowColumn>
                                                <TableRowColumn>{row.ExportedUserName}</TableRowColumn>
                                                <TableRowColumn title={payrollHierarchyNames}>{payrollHierarchyNames}</TableRowColumn>
                                                <TableRowColumn>{row.ExportedData.length}</TableRowColumn>
                                                <TableRowColumn>{row.ExportedData.filter(i => i.Exported).length}</TableRowColumn>
                                                <TableRowColumn>{row.ExportedData.filter(i => !i.Exported).length}</TableRowColumn>
                                                <TableRowColumn style={{ width: 100, textAlign: "center", cursor: "pointer" }}>
                                                    <CSVLink
                                                        key="csvlink"
                                                        data={downloadData}
                                                        style={{ textDecoration: "none", fontSize: 14, fontWeight: 500, padding: 20 }}
                                                        filename={`ExportReport_${moment(row.ExportedDateTime).format("MM-DD-YYYY")}.csv`}
                                                    >
                                                        <FontIcon className="fa fa-download" style={{ fontSize: 20 }} />
                                                    </CSVLink>
                                                </TableRowColumn>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        }
                    </CardText>
                </Card>
            </Paper>
        )
    }
}
